module.exports = __webpack_public_path__ + "img/line-child3.964d0c00.png";